<nz-spin nzSimple class="first-loading" *ngIf="loadingFirst"></nz-spin>
<div class="no-data" *ngIf="!loadingFirst">
  <img src="/assets/svg/no-data-found.svg" alt="No Data" />
  <p *ngIf="type === 'list'">No Data Found</p>
  <p *ngIf="type === 'notification'">No Notification</p>
  <p *ngIf="type === 'unreadNotification'">No Unread Notification</p>
  <p *ngIf="type === 'users'">No Users Found</p>
</div>
